import {lazy, useEffect, useState} from 'react'
import {Navigate} from 'react-router'
import {showErrorHandlerAndFail} from '@freckle/classroom/ts/common/routers/app-router'
import {Routes} from '@freckle/classroom/ts/common/routers/routes'

export const SignUpPageHandler = lazy(() => import('./../../components/page/signup-page'))

export const LoginPageHandler = lazy(() => import('./../../components/page/login-page/login'))

export const SsoMismatchedSchoolHandler = lazy(
  () => import('./../../components/page/sso-mismatched-school')
)

export const ChangePasswordPageHandler = lazy(
  () => import('./../../components/page/change-password-page/handler')
)

export const DeletedLoginHandler = lazy(() => import('./../../../pages/deleted-login'))

export function ErrorRootBoundary() {
  const [errorHandled, setErrorHandled] = useState(false)

  useEffect(() => {
    showErrorHandlerAndFail('Error', 'Something went wrong. Please try again later.')
    setErrorHandled(true)
  }, [])

  if (errorHandled) {
    return <Navigate to={Routes.dashboard()} replace />
  }

  return null
}
